import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quantity-step"
export default class extends Controller {
  static targets = ["input"]
  static values = { increment: { type: Number, default: 1 } }
  
  step({ params: { direction }}) {
    let val = parseInt(this.inputTarget.value)

    if (direction=="increment") {
      val = val + 1;
    } else { 
      val = Math.max(0, val - 1)
    }

    if (this.incrementValue > 1) {
      val = Math.ceil(val / this.incrementValue) * this.incrementValue
    } 

    this.inputTarget.value = val

    this.dispatch("stepped", { detail: { quantity: this.inputTarget.value } })
  }
}
